/*
  Used to mapping the activeFilters to be queryParamFilters (in Array)
  examples:
  queryParamFilters = [
    "created_on lte 2023-08-29T17:00:00Z",
    "created_on gte 2023-08-29T17:00:00Z",
    "status.name eq 'DRAFT'",
  ]
*/

const queryFiltersMappings = {
  eq: (key, value) => {
    return `${key} eq ${value[0]}`
  },
  gte: (key, value) => {
    return `${key.replace(/:gte/g, '')} gte ${value}`
  },
  lte: (key, value) => {
    return `${key.replace(/:lte/g, '')} lte ${value}`
  },
  in: (key, values) => {
    const formattedValues = values.map((value) => `${value}`)
    return `${key.replace(/:in/g, '')} in (${formattedValues.join(' ')})`
  },
}

const filterMappings = {
  'status.name': queryFiltersMappings.eq,
  'created_on:gte': queryFiltersMappings.gte,
  'created_on:lte': queryFiltersMappings.lte,
  'expected_started_on:gte': queryFiltersMappings.gte,
  'expected_started_on:lte': queryFiltersMappings.lte,
  'actual_started_on:gte': queryFiltersMappings.gte,
  'actual_started_on:lte': queryFiltersMappings.lte,
  'vehicle.id:in': queryFiltersMappings.in,
  'driver_user.id:in': queryFiltersMappings.in,
  'user_group.id:in': queryFiltersMappings.in,
}

export default filterMappings
